import {observer} from 'mobx-react';
import {Box, Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery, useTheme} from '@material-ui/core';
import React, {useContext} from 'react';
import OrderSettingsPageStoreContext from '../context';
import {Button, Typography} from '../../../../../common/components/libs';
import {useHistory} from 'react-router';
import {Close, Done} from '@material-ui/icons';

const TariffPromptForm = () => {
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.up('sm'));

    const tariffNames = {
        Simple: 'Простой',
        Basic: 'Базовый',
        Advanced: 'Расширенный'
    }

    const history = useHistory()

    const store = useContext(OrderSettingsPageStoreContext);
    const open = store.forms.tariffPromptForm.open;
    const targetLevel = store.forms.tariffPromptForm.targetLevel;

    const closeForm = () => {
        store.closeTariffPromptForm()
    }

    const toTariffs = () => {
        history.push('/documents/tariff')
        closeForm()
    }

    const additionalItemsByTargetLevel = {
        Simple: [
            'Идеальная замена бумажному меню',
            'Категории и позиции без ограчений',
            'Показ категорий и позиций по времени'
        ],
        Basic: [
            'Заказы в зале, на доставку и на вынос',
            'Скидки и промокоды',
            'Интеграция с айко'
        ],
        Advanced: [
            'Оплата в момент заказа картой',
            'Оплата в момент заказа СБП',
            'Выдача чеков без покупки онлайн-кассы'
        ]
    }

    if (!targetLevel) {
        return <></>
    }

    return (
        <Dialog
            open={open}
            onClose={closeForm}
            aria-labelledby="form-dialog-title"
            fullWidth={true}
            // maxWidth={"sm"}
            // fullScreen={!isSm}
        >
            <DialogTitle id="form-dialog-title" style={{ paddingBottom: 0 }}>
                <Box css={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                    <Close onClick={() => closeForm()}/>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Box css={{ display: 'flex', flexDirection: 'column', gridGap: 10, alignItems: 'center', marginBottom: 10 }}>
                    <Typography variant={'h4'} align={"center"}>
                        Доступно начиная с тарифа {tariffNames[targetLevel]}
                    </Typography>

                    <Typography variant={'subtitle2'}>
                        а еще
                    </Typography>

                    <Box css={{ display: 'flex', flexDirection: 'column', gridGap: 5, marginBottom: 10 }}>
                        {additionalItemsByTargetLevel[targetLevel].map((item) => (
                            <Box css={{ display: 'flex', flexDirection: 'row', gridGap: 10 }}>
                                <Done style={{ color: 'rgba(0, 192, 40, 0.8)' }}/>
                                <Typography>
                                    {item}
                                </Typography>
                            </Box>
                        ))}
                    </Box>

                    <Button color='primary' variant='contained' onClick={() => toTariffs()}>
                        Подключить
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    )
}

export default observer(TariffPromptForm)